import { initSentry as initSentryBase } from '@quadralize/sentry'
import packageJson from '../../package.json'
import { env } from './env'

export function initSentry(): void {
  initSentryBase({
    dsn: env.VITE_SENTRY_DSN,
    isDev: env.DEV,
    release: `quadralize-backoffice@${packageJson.version}`,
    appName: 'Quadralize Backoffice',
    version: packageJson.version,
  })
}
